"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getShareSvgStr = exports.getSaveSvgStr = exports.getCloseSvgStr = void 0;
function getCloseSvgStr() {
    return `<svg width="15px" height="15px" viewBox="0 0 15 15" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="general-flow" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round">
        <g id="picture-/-front-camera-/-share-send" transform="translate(-20.000000, -45.000000)" stroke="#344B60">
            <g id="side-nav" transform="translate(21.000000, 46.000000)">
                <g id="icon-/-exit">
                    <g id="icon-/-burger">
                        <path d="M0.750914431,0.250914431 L12.2609577,11.7609577" id="Line" stroke-width="2.2"></path>
                        <path d="M0.892335787,11.9405069 L12.4023791,0.430463641" id="Line-Copy-2" stroke-width="2.2"></path>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>`;
}
exports.getCloseSvgStr = getCloseSvgStr;
function getSaveSvgStr(customText = 'SAVE') {
    return `<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
	 viewBox="0 0 45 50" style="enable-background:new 0 0 74.4 46;" xml:space="preserve">
<style type="text/css">
	.st0{fill:#344B60;}
	.st1{font-family:'SinhalaSangamMN-Bold';}
	.st2{font-size:0.7em;}
</style>
<g id="general-flow">
	<g id="picture-_x2F_-front-camera-_x2F_-share-send" transform="translate(-59.000000, -591.000000)">
		<g id="save_1_" transform="translate(45.000000, 591.000000)">
			<g id="icon-_x2F_-save">
				<g id="save">
					<path id="Path-6" class="st0" d="M23.2,30c-0.6,0-1-0.4-1-1s0.4-1,1-1h28c0.6,0,1,0.4,1,1s-0.4,1-1,1H23.2z"/>
					<g id="arrow" transform="translate(8.000000, 0.000000)">
						<g id="icon-_x2F_-arrow">
							<path id="Combined-Shape" class="st0" d="M29.6,20.5l3.7-3.3c0.4-0.4,1-0.3,1.4,0.1c0.4,0.4,0.3,1-0.1,1.4l-6.1,5.6l-5.9-5.6
								c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0l3.7,3.4V8.2c0-0.6,0.4-1,1-1c0.6,0,1,0.4,1,1v12.3H29.6z"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
</g>
<text x="50%" y="90%" dominant-baseline="middle" class="st0 st1 st2" text-anchor="middle">${customText}</text>
</svg>
`;
}
exports.getSaveSvgStr = getSaveSvgStr;
function getShareSvgStr(customText = 'SHARE') {
    return `<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 45 50" style="enable-background:new 0 0 74.4 46;" xml:space="preserve">
<style type="text/css">
	.st0{fill:#344B60;}
	.st1{font-family:'SinhalaSangamMN-Bold';}
	.st2{font-size:0.7em;}
</style>
<g id="Design-v3">
	<g id="picture-copy" transform="translate( -105.000000, -540.000000 )">
		<g id="share" transform="translate(108.000000, 547.000000)">
			<g id="icon-_x2F_-share" transform="translate(10.000000, 0.000000)">
				<g>
					<path id="Rectangle-6" class="st0" d="M2.7,14.5v7.6h13.6v-7.6H2.7z M1.4,13.2h16.3v9c0,0.8-0.6,1.4-1.4,1.4H2.7
						c-0.7,0-1.4-0.6-1.4-1.4V13.2z"/>
					<path id="Rectangle-6-Copy" class="st0" d="M1.4,9v4.2h16.3V9H1.4z M1.4,7.6h16.3C18.4,7.6,19,8.2,19,9v4.2
						c0,0.8-0.6,1.4-1.4,1.4H1.4c-0.7,0-1.4-0.6-1.4-1.4V9C0,8.2,0.6,7.6,1.4,7.6z"/>
					<polygon id="Path-9" class="st0" points="10.3,22.4 9,22.4 9,8.7 10.3,8.7 					"/>
					<path id="Oval-7" class="st0" d="M10.2,6.8L9.7,8.2L9.2,6.9C7.6,5.1,6.8,3.8,6.8,2.8C6.8,1.2,8,0,9.5,0s2.7,1.2,2.7,2.8
						C12.2,3.7,11.5,5.1,10.2,6.8z M10.9,2.8c0-0.8-0.6-1.4-1.4-1.4S8.1,2,8.1,2.8c0,0.5,0.5,1.3,1.5,2.5
						C10.4,4.1,10.9,3.2,10.9,2.8z"/>
					<path id="Oval-7_1_" class="st0" d="M10.6,8l-1,0L10,7c1-2.3,1.8-3.7,2.6-4.2c1.3-0.8,3-0.5,3.8,0.8s0.4,3-0.8,3.8
						C14.8,7.9,13.1,8.1,10.6,8z M14.8,6.3c0.6-0.4,0.8-1.3,0.4-1.9C14.8,3.7,14,3.6,13.3,4c-0.4,0.3-1,1.2-1.7,2.6
						C13.3,6.7,14.4,6.5,14.8,6.3z"/>
					<path id="Oval-7_2_" class="st0" d="M8.7,8l1,0L9.3,7c-1-2.3-1.8-3.7-2.6-4.2C5.4,2,3.7,2.4,2.9,3.6s-0.4,3,0.8,3.8
						C4.5,7.9,6.1,8.1,8.7,8z M4.4,6.3C3.8,5.8,3.6,5,4,4.4S5.3,3.6,5.9,4c0.4,0.3,1,1.2,1.7,2.6C5.9,6.7,4.8,6.5,4.4,6.3z"/>
				</g>
			</g>
		</g>
	</g>
</g>
<text x="50%" y="90%" dominant-baseline="middle" class="st0 st1 st2" text-anchor="middle">${customText}</text>
</svg>`;
}
exports.getShareSvgStr = getShareSvgStr;
//# sourceMappingURL=images.js.map